import {RESET_AVERAGE_PRICE_RESPONSE} from "../mutations/mutations-types";

export default {
    resetResponseData({ commit }) {
        commit(RESET_AVERAGE_PRICE_RESPONSE)
    }
}
